module.exports = __webpack_public_path__ + "static/g3-1185579e8cd5b1b30e716be76e71450a.svg";